"use strict";
/*
 * Copyright (C) 2018 Spanning Cloud Apps.  All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertRuleTriggerType = void 0;
/**
 * The types of triggers an alert rule can use.
 */
var AlertRuleTriggerType;
(function (AlertRuleTriggerType) {
    // This trigger type allows us to check for the number of objects backed up to be at least (>=) a specific value.
    AlertRuleTriggerType["AT_LEAST"] = "at_least";
    // This trigger type allows us to check for the number of objects backed up to be at most (<=) a specific value.
    AlertRuleTriggerType["AT_MOST"] = "at_most";
    // This trigger type allows us to check for decreases in the number of objects backed up from one backup to the next.
    AlertRuleTriggerType["DECREASE"] = "decrease";
    // This trigger type allows us to check for increases in the number of objects backed up from one backup to the next.
    AlertRuleTriggerType["INCREASE"] = "increase";
})(AlertRuleTriggerType || (exports.AlertRuleTriggerType = AlertRuleTriggerType = {}));
//# sourceMappingURL=AlertRuleTriggerType.js.map